// M10-16235: e-invoice reference (QR/IRN/BOTH + IRN) checks run before an e-invoice can be accepted.
// Mirrors resolveEinvoiceReference in backend-oms-svc.

export const EINVOICE_REF_TYPES = ["QR", "IRN", "BOTH"] as const;
export type EInvoiceRefType = (typeof EINVOICE_REF_TYPES)[number];

// An IRN is the 64-character hex SHA-256 hash issued by the IRP
export const IRN_REGEX = /^[0-9a-fA-F]{64}$/;

export const isValidIrn = (irn?: string | null) => IRN_REGEX.test((irn || "").trim());

export const requiresIrn = (refType?: string | null) => refType === "IRN" || refType === "BOTH";

export const getEInvoiceReferenceErrors = (refType?: string | null, irn?: string | null) => {
  const errors: { refType?: string; irn?: string } = {};
  if (!refType) {
    errors.refType = "Select the QR/IRN reference type";
  } else if (requiresIrn(refType)) {
    if (!(irn || "").trim()) errors.irn = `IRN is required for reference type ${refType}`;
    else if (!isValidIrn(irn)) errors.irn = "IRN must be exactly 64 hexadecimal characters";
  }
  return errors;
};
